<template>
  <div class="b-fff pl10 pr10" style="height:100%;">
    <a-tabs size="small" v-model:activeKey="state.activeKey">
      <a-tab-pane :key="1" tab="发布站内信" force-render>
        <a-form
          :model="state"
          :rules="rules"
          ref="formRef"
          style=" margin:auto;padding-top: 30px"
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 14 }"
        >
          <a-form-item label="标题:" name="title">
            <a-input v-model:value="state.title"></a-input>
          </a-form-item>
          <a-form-item label="内容:" name="message">
            <QuillEditor
              ref="myQuillEditor"
              v-model:content="state.message"
              theme="snow"
              contentType="html"
              :options="options"
            />
          </a-form-item>
          <a-form-item :wrapper-col="{ span: 14, offset: 4 }" class="tac">
            <a-button type="primary" @click="submit">提交</a-button>
          </a-form-item>
        </a-form>
      </a-tab-pane>
      <a-tab-pane :key="2" tab="待审核列表" force-render>
        <a-row type="flex" justify="end" class="mb10">
          <a-button type="primary" size="small" @click="getUnAudit"
            >刷新</a-button
          >
        </a-row>
        <a-table
          :rowKey="(record, index) => record.id"
          size="small"
          bordered
          :columns="columns"
          :data-source="unAuditList"
        >
          <template #message="{record}">
            <span v-if="record.type === 3">[意见反馈]</span>
            <span v-html="record.message"></span>
          </template>
          <template #action="{record}">
            <a-button size="small" type="link" @click="toAudit(record)"
              >通过</a-button
            >
          </template>
          <template #status="{record}">
            <span>{{ state.statusStr[record.status] }}</span>
          </template>
        </a-table>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script setup>
import { reactive, toRefs, ref, watch } from 'vue'
import useAPI from 'UseApi'
import '@vueup/vue-quill/dist/vue-quill.snow.css'
import { QuillEditor, Quill } from '@vueup/vue-quill'
import { message } from 'ant-design-vue'
const APIS = useAPI(null, [4231])
const formRef = ref(null)
const state = reactive({
  title: null,
  message: null,
  type: 2, // 1 自动上报菜单   2 管理员发布的消息  3、发表意见
  activeKey: 1,
  statusStr: {
    0: '未审核',
    1: '已审核'
  }
})
const rules = {
  title: [
    { required: true, message: '标题不能为空', trigger: 'blur', type: 'any' },
    { min: 1, max: 20, message: 'Length should be 1 to 20', trigger: 'blur' }
  ],
  message: [
    {
      required: true,
      message: '请输入内容'
    }
  ]
}
const columns = [
  {
    title: '消息内容',
    dataIndex: 'message',
    key: 'message',
    slots: {
      customRender: 'message'
    }
  },
  {
    title: '创建人',
    dataIndex: 'userName',
    key: 'userName',
    width: '120px'
  },
  {
    title: '提交时间',
    dataIndex: 'createdAt',
    key: 'createdAt',
    width: '180px'
  },
  {
    title: '审核状态',
    dataIndex: 'status',
    key: 'status',
    width: '120px',
    slots: {
      customRender: 'status'
    }
  },
  {
    title: '操作',
    width: '120px',
    slots: {
      customRender: 'action'
    }
  }
]
watch(
  () => state.activeKey,
  val => {
    if (val === 2) {
      getUnAudit()
    }
  }
)
const options = reactive({
  modules: {
    toolbar: {
      container: [
        [{ size: ['small', false, 'large'] }],
        ['bold', 'italic', 'underline'],
        [{ header: 1 }, { header: 2 }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['link'],
        [{ color: [] }, { background: [] }],
        [{ align: [] }]
      ]
    },
    history: {
      delay: 1000,
      maxStack: 50,
      userOnly: false
    }
  }
})
const myQuillEditor = ref(null)
const { unAuditList, getUnAudit } = APIS.v1_station_letter_unAudit_post_({})
const { trackLetter } = APIS.v1_station_letter_create_post_()
const { toAudit } = APIS.v1_station_letter_audit_post_(getUnAudit)
const submit = () => {
  formRef.value.validate().then(() => {
    trackLetter(state, res => {
      if (res.success) {
        state.message = ''
        myQuillEditor.value.setContents('')
        Object.assign(state, {
          title: null,
          message: null
        })
        message.success('发送成功')
      } else {
        message.success('服务器异常，请重新操作')
      }
    })
  })
}
</script>
<style>
.ql-container {
  height: 300px;
}
</style>
